export default __webpack_public_path__ + "static/media/g10-transportes.7672bcf7.svg";